export const getApiRoutes = () => ({
  search: window.searchRoute
})
